@for (field of systemFields; track field.key; let isLast = $last) {
  <div fxLayoutGap="20px">
    <div fxLayout="column" class="form-item">
      <b class="item-title" [innerHTML]="field.key | safeHtml"></b>
      <span
        class="value"
        [ngClass]="{
          'attribute-value-no-value': !field.value
        }"
        [innerHTML]="
          (field.value?.length > 0 ? field.value : noValueText) | safeHtml
        "
      ></span>
      @if (!isLast || flatAttributes?.length) {
        <mat-divider class="divider"></mat-divider>
      }
    </div>
  </div>
}

@for (attribute of flatAttributes; track attribute.name; let isLast = $last) {
  <div fxLayoutGap="20px">
    <div fxLayout="column" class="form-item">
      <b
        class="item-title"
        [innerHTML]="
          (useDescription
            ? attribute.description?.length
              ? attribute.description
              : attribute.name
            : attribute.name
          ) | safeHtml
        "
      ></b>
      @if (attribute?.type === 'Skill') {
        <div class="value">
          <skill
            [selectedSkillLevel]="
              attribute.attributes[0].attributeDefinitionValueListItem
            "
          ></skill>
        </div>
      }
      @if (attribute?.type === 'StarRating') {
        <div class="value">
          <app-star-rating-attribute
            [selectedStarRating]="
              attribute.attributes[0].attributeDefinitionValueListItem
            "
          ></app-star-rating-attribute>
        </div>
      }
      @if (attribute?.type === 'Complex') {
        @for (
          complexAttributeValue of attribute?.complexAttributeValues;
          track complexAttributeValue
        ) {
          <div class="value">
            <app-complex-field-viewer
              [complexAttributeValue]="complexAttributeValue"
            ></app-complex-field-viewer>
          </div>
        }
      }
      @if (
        attribute?.type !== 'EncryptedField' &&
        attribute?.type !== 'Complex' &&
        attribute?.type !== 'Skill' &&
        attribute?.type !== 'StarRating'
      ) {
        @for (attrValue of attribute.attributes; track attrValue) {
          <span
            class="value"
            [ngClass]="{
              'attribute-value-no-value': !attrValue.hasValue()
            }"
            [innerHTML]="
              (attrValue.hasValue() ? attrValue.value : noValueText) | safeHtml
            "
          ></span>
        }
      }
      @if (attribute?.type === 'EncryptedField') {
        @for (attrValue of attribute.attributes; track attrValue) {
          <span
            class="value"
            [ngClass]="{
              'attribute-value-no-value': !attrValue.hasValue()
            }"
            [innerHTML]="
              (attrValue.hasValue() ? '***' : noValueText) | safeHtml
            "
          ></span>
        }
      }
      @if (!isLast) {
        <mat-divider class="divider"></mat-divider>
      }
    </div>
  </div>
}
